const items = document.querySelectorAll(".js-faq__item"),
  titles = document.querySelectorAll(".js-faq__title");

titles.forEach((title) => {
  title.addEventListener("click", function () {
    let target = title.getAttribute("data-target");
    toggleItems(target);
  });
});

function toggleItems(target) {
  let items = document.querySelectorAll("[data-rubric='"+ target + "']");
    items.forEach(item => {
      let height = item.scrollHeight
      if (item.classList.contains('active')) {
        item.classList.remove('active');
        item.style.height = '0px';
      } else {
        item.classList.add('active');
        item.style.height = height + 'px';
      }
    });
}
